module.exports = __webpack_public_path__ + "img/file-manager-diff.97624c13.png";